import { render, staticRenderFns } from "./accountStatus.vue?vue&type=template&id=511622c8&scoped=true"
import script from "./accountStatus.vue?vue&type=script&lang=js"
export * from "./accountStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511622c8",
  null
  
)

export default component.exports